import { render, staticRenderFns } from "./ManageTyoriSetting.vue?vue&type=template&id=5f6d5288&"
import script from "./ManageTyoriSetting.vue?vue&type=script&lang=js&"
export * from "./ManageTyoriSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports